import Category from './category'
import Products from './products'

export default async function loadCategoryContent(
  categoryOptions,
  productOptions,
) {
  const categoryId = await Category.resolveId(categoryOptions)
  const [category, initialProducts] = await Promise.all([
    Category.getCategoryById({ ...categoryOptions, categoryId }),
    Products.getList({ ...productOptions, categoryId }).then(
      (products) => ({ products }),
      (error) => ({ error }),
    ),
  ])

  // Preserve the metadata endpoint's authority if a category is canonicalized.
  if (!category?.id_category) throw new Error('Category not found')
  if (
    String(category.id_category) === String(categoryId) &&
    initialProducts.error
  )
    throw initialProducts.error
  const products =
    String(category.id_category) === String(categoryId)
      ? initialProducts.products
      : await Products.getList({
          ...productOptions,
          categoryId: category.id_category,
        })
  return { category, products }
}
